import React, { useState, createContext, ReactElement } from 'react';
import createPersistedState from '@/hooks/use-persisted-state';

export const CopyPasteContext = createContext({
  extraGroups: [],
  setExtraGroups: (extraGroups: []) => {},
  variant: null,
  setVariant: (variant: null) => {},
  productOfVariantId: null,
  setProductOfVariantId: (productOfVariantId: null) => {},
  categories: [] as string[],
  setCategories: (categories: string[]) => {},
});

const useCopiedCategories = createPersistedState<string[]>('copied-categories');
// const useCopiedVariant = createPersistedState('copied-variants')
// const useCopiedExtraGroups = createPersistedState('copied-extra-groups')
// const useCopiedVariants = createPersistedState('copied-product-of-variant')

type CopyPasteContextProviderProps = {
  children: ReactElement;
};
function CopyPasteContextProvider({ children }: CopyPasteContextProviderProps) {
  const [variant, setVariant] = useState(null);
  const [extraGroups, setExtraGroups] = useState([]);
  const [productOfVariantId, setProductOfVariantId] = useState(null);

  // can be used across browser tabs
  const [categories, setCategories] = useCopiedCategories([]);

  return (
    <CopyPasteContext.Provider
      value={{
        extraGroups,
        setExtraGroups,
        variant,
        setVariant,
        productOfVariantId,
        setProductOfVariantId,
        categories,
        setCategories,
      }}
    >
      {children}
    </CopyPasteContext.Provider>
  );
}

export default CopyPasteContextProvider;
